import React from "react";
import { Button } from "antd";
import NoMoreConflicts from "./NoMoreConflicts";
import { FormattedMessage } from "react-intl";
import ReplacementsModal from "../../employees/replacements/ReplacementsModal";

const SchedulingModal = (props) => {
  const {
    onCancel,
    onSubmitForceAbsences,
    onCommit,
    visible,
    hasApprovedScheduling,
    createLoading,
    absenceValues,
    data,
    triggerFetch,
    triggerQueryTimestamp,
    isLoading,
  } = props;

  const AbscenceActions = () => (
    <div className="abscenceActions">
      <div>
        <Button type="text" onClick={onCancel}>
          <FormattedMessage id={`app.actions.cancel`} />
        </Button>
        <Button
          type="primary"
          onClick={onSubmitForceAbsences}
          disabled={hasApprovedScheduling || createLoading}
          loading={createLoading}
        >
          <FormattedMessage id={`app.actions.save_employee_absences`} />
        </Button>
      </div>
    </div>
  );

  const NoConflicts = () => (
    <NoMoreConflicts
      onCancel={onCancel}
      onCommit={() => onCommit(false)}
      createLoading={createLoading}
    />
  );
  const hasAbsencesConflicts = (data && data.length) || isLoading > 0;
  return (
    <ReplacementsModal
      visible={visible}
      onHide={onCancel}
      triggerFetch={triggerFetch}
      triggerQueryTimestamp={triggerQueryTimestamp}
      absenceValues={absenceValues}
      abscenceActions={<AbscenceActions />}
      noConflicts={<NoConflicts />}
      hasAbsencesConflicts={hasAbsencesConflicts}
      title={
        <FormattedMessage id={`app.absences.conflictingSchedulingTitle`} />
      }
      subTitle={
        <FormattedMessage id={`app.absences.conflictingSchedulingSubTitle`} />
      }
    />
  );
};

export default SchedulingModal;
